/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_REBATE_PROGRAM_CONTRACT_REPORT =
  'GET_REBATE_PROGRAM_CONTRACT_REPORT';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_CONTRACT_REPORT = 'REFRESH_CONTRACT_REPORT';
export const IS_LOADING = 'IS_LOADING';
export const SET_CONTRACT_MFG_GRID = 'SET_CONTRACT_MFG_GRID';
export const SET_CONTRACT_DRUG_FAMILY_GRID = 'SET_CONTRACT_DRUG_FAMILY_GRID';
export const SET_CONTRACT_MARKET_BASKET_GRID =
  'SET_CONTRACT_MARKET_BASKET_GRID';
export const SET_CONTRACT_GRID = 'SET_CONTRACT_GRID';
export const SET_DRUG_FAMILY_CONTRACT_GRID = 'SET_DRUG_FAMILY_CONTRACT_GRID';
export const SET_OPEN_VALUE = 'SET_OPEN_VALUE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
